
  import React from "react"
  import Component from "/opt/build/repo/src/layouts/mainLayout.jsx"
  import data from "/opt/build/repo/.cache/json/layout-main-layout-lv.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/main-layout-lv.js